import styled, { css } from 'styled-components';

export const BannerCarouselWrapper = styled.div<{
  nextLabelText: string;
  prevLabelText: string;
  direction: 'ltr' | 'rtl';
}>`
  ${props =>
    props.direction === 'rtl' &&
    css`
      [class*='Iconstyle__Icon'] {
        transform: scaleX(-1);
        -webkit-transform: scaleX(-1);
        -moz-transform: scaleX(-1);
      }

      [class*='CarouselLoaderPagerstyle__Title'] {
        text-align: right;
      }
      
      [class*='Paragraphstyle__Paragraph'] {
        text-align: right;
      }
      
      [class*='Headingstyle__Heading'] {
        text-align: right;
      }
    `}
  
  ul > li:first-child {
    [class*='Interactionstyle__Button'] {
      font-size: 0px;

      @media only screen and (min-width: 1025px) {
        display: none;
      }
    }
      
    [class*='Interactionstyle__Button']::after {
      content: '${props => props.prevLabelText}';
      font-size: 18px;

      @media only screen and (max-width: 1024px) {
        display: none;
      }
    }
  }
  
    ul > li:last-child {
    [class*='Interactionstyle__Button'] {
      font-size: 0px;

      @media only screen and (min-width: 1025px) {
        display: none;
      }
    }

    [class*='Interactionstyle__Button']::before {
      content: '${props => props.nextLabelText}';
      font-size: 18px;

      @media only screen and (max-width: 1024px) {
        display: none;
        }
      }
    }
  }

  [class*='ContentWrapperstyle__ContentWrapper'] {
    @media only screen and (max-width: 1024px) {
        height: 100%;
      }
  }

  [class*='FunctionalCarouselstyle__Carousel-sc-'] {
    margin: 0;
    .slick-slide > div {
      margin: 0;
    }
    [class*='Interactionstyle__Button-sc-'] {
      box-shadow: none !important;
    }

    [class*='FunctionalCarouselstyle__CarouselLoaderPager-sc-'] {
      padding: 20px;

      [class*='FunctionalCarouselstyle__CarouselLoaderPagerArrow-sc-'] {
        align-self: flex-end;
        padding-bottom: 2px;
        margin: 0 70px;

        & > [class*='Interactionstyle__Button-sc-'] {
          display: flex;
          align-items: center;
        }
      }

      [class*='CarouselLoaderPagerstyle__Title-sc-'] {
        min-height: unset;
        padding-bottom: 0;
      }
    }
  }
`;
